import axios from "@/utils/request";

// 码包下载设备授权-列表
export const codeWrapDeviceList = (params) => {
  return axios.request({
    url: "codeWrap/device/list",
    method: "get",
    params
  });
};

// 码包下载设备授权-详情（不含 device_secret）
export const codeWrapDeviceDetail = (id) => {
  return axios.request({
    url: "codeWrap/device/detail/" + id,
    method: "get"
  });
};

// 码包下载设备授权-添加（响应会返回一次 device_secret）
export const codeWrapDeviceCreate = (data) => {
  return axios.request({
    url: "codeWrap/device/create",
    method: "post",
    data
  });
};

// 码包下载设备授权-编辑（不可改 device_secret）
export const codeWrapDeviceUpdate = (id, data) => {
  return axios.request({
    url: "codeWrap/device/update/" + id,
    method: "put",
    data
  });
};

// 码包下载设备授权-启停切换（status: 0 禁用 / 1 允许）
export const codeWrapDeviceStatus = (id, status) => {
  return axios.request({
    url: "codeWrap/device/status/" + id + "/" + status,
    method: "put"
  });
};

// 码包下载设备授权-删除（软删）
export const codeWrapDeviceDelete = (id) => {
  return axios.request({
    url: "codeWrap/device/delete/" + id,
    method: "delete"
  });
};

// 码包下载设备授权-重置秘钥（响应会返回一次新 device_secret）
export const codeWrapDeviceResetSecret = (id) => {
  return axios.request({
    url: "codeWrap/device/resetSecret/" + id,
    method: "put"
  });
};
